/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRefundDetailsEditor extends _Ext.ItemGridEditor<ECommRefundDetailsRow> {
        protected getColumnsKey() { return "ECommerce.ECommRefundDetails"; }
        protected getDialogType() { return ECommRefundDetailsDialog; }
        protected getLocalTextPrefix() { return ECommRefundDetailsRow.localTextPrefix; }
        ExchangeRate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);
            var x = 0;
        }

        
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}